export const messageCenterRoutes = [{
    path: '/messageCenter',
    component: () => import('./messageCenter.vue'),

    meta: {
        crumbName: '消息中心',
    },
    children: [
        {
            path: 'message',
            name: '消息通知',
            component: () => import('../Message.vue'),
            meta: {
                //标明是否需要登录后才能访问
                auth: true
            }
        },
        {
            path: 'allMessage',
            name: '全部消息',
            component: () => import('../allMessage.vue'),
            meta: {
                //标明是否需要登录后才能访问
                auth:true
            }
        },
        {
            path: 'seeMessage',
            name: '已读消息',
            component: () => import('../seeMessage'),
            meta: {
                //标明是否需要登录后才能访问
                auth:true
            }
        },
        {
            path: 'notseeMessage',
            name: '未读消息',
            component: () => import('../notseeMessage'),
            meta: {
                //标明是否需要登录后才能访问
                auth: true
            }
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/pages/message/router/message.router.js